import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicNewsList from '../EpicNewsList/epic.news.list.vue';
import EpicBody from '../EpicBody/epic.body.vue';
import ASpaceInBetweenAnother from '../../shared/ASpaceInBetweenAnother/a.space.inbetween.another.vue';
import { CommonConfig } from '../../configs/config.common';

@Component({
    components: {
        EpicNewsList,
        EpicBody,
        ASpaceInBetweenAnother
    }
})
export default class EpicNews extends Vue {
    public title: string = 'latest news';
    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public getMktingUrl() {
        const configs = new CommonConfig();
        return `${configs.marketingAdUrl}`;
    }
    public getRifoDesign(path: string) {
        const configs = new CommonConfig();
        return `${configs.rifoDesignAssetsUrl}${path}`;
    }
}
